import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';
import NavigatorControlsLocation from '../enums/NavigatorControlsLocation';

type logMapLayerButtonTappedParams = {
  map_location: MapLocation;
  navigator_controls_location?: NavigatorControlsLocation;
};

/**
 * A user taps the ‘layers’ icon from a map view page to bring up the map base layer and overlay selection drawer.
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.navigator_controls_location - Denotes which location the button was tapped from, e.g. the navigator screen on the phone app, the main screen of the watch app, or the complication or tile on the watch app
 */
const logMapLayerButtonTapped = ({ map_location, navigator_controls_location }: logMapLayerButtonTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'map layer button tapped',
    { 'map location': map_location, 'navigator controls location': navigator_controls_location },
    callback
  );
};

export default logMapLayerButtonTapped;
